// src/services/auth.service.js
import api from './api';

const authService = {
  login: async (credentials) => {
    try {
      console.log('🔐 Login attempt with:', { email: credentials.email });
      console.log('📡 API Base URL:', api.defaults.baseURL);
      
      // CORRECT: Backend expects "identifier" field, not "email" or "username"
      const loginPayload = {
        identifier: credentials.email || credentials.username,
        password: credentials.password,
      };
      
      console.log('📤 Sending payload:', { identifier: loginPayload.identifier });
      
      const response = await api.post('/auth/login', loginPayload);
      
      console.log('✅ Login response:', response.data);
      
      // Store tokens if present
      if (response.data?.data?.accessToken) {
        localStorage.setItem('accessToken', response.data.data.accessToken);
      }
      
      if (response.data?.data?.refreshToken) {
        localStorage.setItem('refreshToken', response.data.data.refreshToken);
      }
      
      // Store user data
      if (response.data?.data?.user) {
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Login error details:');
      console.error('Status:', error.response?.status);
      console.error('Response Data:', error.response?.data);
      
      // Handle specific error cases
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
        throw new Error('Cannot connect to server. Is the backend running?');
      }
      
      if (error.response?.status === 404) {
        throw new Error('Login endpoint not found. Check API configuration.');
      }
      
      if (error.response?.status === 401) {
        throw new Error(error.response.data?.message || 'Invalid credentials');
      }
      
      if (error.response?.status === 400) {
        throw new Error(error.response.data?.message || 'Invalid request');
      }
      
      // Return the error message from backend if available
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          'Login failed. Please try again.';
      
      throw new Error(errorMessage);
    }
  },

  logout: async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      
      if (refreshToken) {
        await api.post('/auth/logout', { refreshToken });
      }
      
      // Clear all stored data
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedCompanyId');
      
      return { success: true };
    } catch (error) {
      // Even if logout fails, clear local storage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedCompanyId');
      
      console.error('Logout error:', error);
      throw error;
    }
  },

  refreshToken: async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }
      
      const response = await api.post('/auth/refresh', { refreshToken });
      
      if (response.data?.data?.accessToken) {
        localStorage.setItem('accessToken', response.data.data.accessToken);
      }
      
      return response.data;
    } catch (error) {
      console.error('Token refresh error:', error);
      
      // Clear tokens if refresh fails
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      
      throw error;
    }
  },

  getProfile: async () => {
    try {
      const response = await api.get('/auth/me');
      return response.data;
    } catch (error) {
      console.error('Get profile error:', error);
      throw error;
    }
  },

  changePassword: async (passwordData) => {
    try {
      const response = await api.post('/auth/change-password', passwordData);
      return response.data;
    } catch (error) {
      console.error('Change password error:', error);
      throw error;
    }
  },

 

  forgotPassword: async (email) => {
    try {
      
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      console.error('Forgot password error:', error);
     
      const message = error.response?.data?.message || 'Failed to send reset link';
      throw new Error(message);
    }
  },

  resetPassword: async (token, newPassword) => {
    try {
      
      const response = await api.post(`/auth/reset-password/${token}`, { 
        password: newPassword 
      });
      return response.data;
    } catch (error) {
      console.error('Reset password error:', error);
      const message = error.response?.data?.message || 'Failed to reset password';
      throw new Error(message);
    }
  },
  
// ... rest of the file

 

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('accessToken');
    const user = localStorage.getItem('user');
    return !!(token && user);
  },

  // Get stored user data
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (error) {
        console.error('Error parsing user data:', error);
        return null;
      }
    }
    return null;
  },
};

export default authService;